import React from 'react';
import './Licenses.css';

const Licenses = () => {
  const licenses = [
    {
      icon: '⚡',
      title: 'لایسنس cPanel / WHM',
      desc: 'لایسنس اورجینال cPanel با فعال‌سازی آنی و پشتیبانی رسمی Cpanel LLC',
    },
    {
      icon: '🔧',
      title: 'لایسنس DirectAdmin',
      desc: 'لایسنس DirectAdmin با قیمت رقابتی، نصب و راه‌اندازی توسط تیم افرسل',
    },
    {
      icon: '🛡️',
      title: 'لایسنس ImmunifyAV',
      desc: 'آنتی‌ویروس ایمونایفای برای محافظت از سرور در برابر بدافزارها',
    },
    {
      icon: '🚀',
      title: 'لایسنس LiteSpeed',
      desc: 'وب‌سرور لایت‌اسپید با عملکرد فوق‌العاده و کش پیشرفته',
    },
    {
      icon: '☁️',
      title: 'لایسنس CloudLinux',
      desc: 'سیستم‌عامل ابری برای هاستینگ با ایزوله‌سازی کاربران',
    },
    {
      icon: '💾',
      title: 'لایسنس JetBackup',
      desc: 'راه‌حل حرفه‌ای بکاپ‌گیری با قابلیت بازیابی سریع',
    },
    {
      icon: '📦',
      title: 'لایسنس Softaculous',
      desc: 'نصب خودکار بیش از ۴۰۰ اسکریپت با یک کلیک',
    },
    {
      icon: '🖥️',
      title: 'لایسنس Virtualizor',
      desc: 'مدیریت مجازی‌سازی VPS با کنترل کامل و API پیشرفته',
    },
    {
      icon: '🌐',
      title: 'لایسنس Plesk',
      desc: 'کنترل پنل حرفه‌ای Plesk برای ویندوز و لینوکس',
    },
    {
      icon: '🔑',
      title: 'لایسنس KernelCare',
      desc: 'آپدیت کرنل بدون نیاز به ریبوت سرور',
    },
    {
      icon: '💻',
      title: 'لایسنس SolusVM',
      desc: 'مدیریت ماشین‌های مجازی با رابط کاربری ساده و قدرتمند',
    },
    {
      icon: '🏷️',
      title: 'لایسنس WHM Reseller',
      desc: 'لایسنس رسیلر برای مدیریت هاستینگ فروشندگان',
    },
    {
      icon: '🏷️',
      title: 'لایسنس DirectAdmin Reseller',
      desc: 'لایسنس رسیلر DirectAdmin با قیمت مناسب',
    },
    {
      icon: '🔧',
      title: 'لایسنس CPNginx',
      desc: 'وب‌سرور Nginx برای cPanel با عملکرد بهینه',
    },
    {
      icon: '📄',
      title: 'لایسنس SitePad',
      desc: 'ساخت وب‌سایت با بیش از ۱۰۰ قالب آماده',
    },
    {
      icon: '📊',
      title: 'لایسنس OSM',
      desc: 'سیستم مدیریت کسب‌وکار آنلاین با امکانات کامل',
    },
    {
      icon: '🎵',
      title: 'لایسنس WHMCS Sonic',
      desc: 'ماژول پیشرفته برای اتوماسیون هاستینگ',
    },
    {
      icon: '📧',
      title: 'لایسنس MailScaner',
      desc: 'سیستم امنیتی ایمیل با اسکن ویروس و هرزنامه',
    },
  ];

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="lic-sec" id="licenses">
      <div className="wrap">
        <div className="sec-header">
          <span className="sec-tag">لایسنس و نرم‌افزار</span>
          <h2 className="sec-h">ابزار حرفه‌ای هاستینگ</h2>
          <p className="sec-p">لایسنس اورجینال، نصب و پشتیبانی فارسی</p>
        </div>
        <div className="lic-grid">
          {licenses.map((lic, i) => (
            <div key={i} className="lic-card">
              <span className="lic-ico">{lic.icon}</span>
              <div className="lic-h">{lic.title}</div>
              <div className="lic-d">{lic.desc}</div>
              <button className="svc-link" onClick={() => scrollTo('contact')}>استعلام قیمت ←</button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Licenses;
